import React, { useState, useContext, useEffect } from "react";
import { Context as AuthContext } from '../contexts/AuthContext'
import { useParams } from 'react-router-dom';
import { useHistory, useAccountingBooks, useIsDesktop } from '../hooks';
import { themeColors } from '../constants/globalColors'
import {
  FullPageLoader,
  AccountingBookLabel,
  AccountingBooksHeader,
  AccountingBookAddLabel,
  AccountingBookDeletedLabel,
  TopRightIcon,
  Svg
} from '../components';

const styles = {
  bg: {
    width: '100%',
    height: '100vh',
    maxHeight: '-webkit-fill-available',
    overflow: 'hidden',
    position: 'relative',
  },
  books: {
    paddingTop: '14px',
    paddingBottom: '100px',
    height: 'calc(100vh - 40px)',
    overflow: 'auto',
    background: 'white',
  },
  loading: {
    display: 'flex',
    height: 'calc(100vh - 60px)',
    justifyContent: 'center',
    alignItems: 'center',
  }
}

const AccountingBookSummaryPage = ({
  users,
}) => {
  const { state: authState } = useContext(AuthContext)
  const { group_id } = useParams();
  const [disableForm, setDisableForm] = useState(true)
  const [books, group, loading, currentBook, setCurrentBook] = useAccountingBooks(authState)
  const history = useHistory();
  const isDesktop = useIsDesktop()

  useEffect(() => {
    if (!loading) {
      setDisableForm(false)
    }
  }, [loading])

  const objects = books.map(book => {
    return <AccountingBookLabel
      disabled={disableForm}
      current={currentBook ? currentBook.uuid === book.uuid : false}
      handleSetCurrent={(id) => handleSetAsCurrent(id)}
      key={book.uuid}
      object={book}/>
  })

  const handleSetAsCurrent = (uuid) => {
    setCurrentBook({ uuid: uuid })

    if (uuid) {
      authState.api.updateCurrentAccountingBook(group.id, uuid)
        .then((res) => {
          setCurrentBook({ uuid: res.data.accounting_book.uuid })
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }

  return(
    <>
      <div style={isDesktop ? { ...styles.bg, height: '100%' } : styles.bg}>
        { !isDesktop &&
          <>
            <AccountingBooksHeader group={group} title={'帳本列表'} color={themeColors.gray400}/>
            <TopRightIcon
              clicked={() => history.navigateTo('groupMembersPage', { group_id })}
              style={{ fontSize: '20px', right: 20 }}>
              <Svg icon='person' size='24' className='black'/>
            </TopRightIcon>
          </>
        }
        {
          loading ?
            null
            :
            <div style={isDesktop ? { ...styles.books, height: '100%' } : styles.books}>
              {objects}
              <AccountingBookAddLabel clicked={() => { history.navigateTo("accountingBookCreationPage", { group_id }) }}></AccountingBookAddLabel>
              <AccountingBookDeletedLabel clicked={() => { history.navigateTo("deletedAccountingBooksPage", { group_id }) }}></AccountingBookDeletedLabel>
            </div>
        }
      </div>
      {
        disableForm ?
          <FullPageLoader /> : null

      }
    </>
  )
}

export default AccountingBookSummaryPage
